module.exports = __webpack_public_path__ + "static/20_Disney-65b088d071fdec19859caa266c85fb02.png";